import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { ChartModel } from '@modules/private/roadmap/data/utils/chart-geometry.util'

/**
 * Dibuja una gráfica ya calculada (F-156): velocidad, burn-up y bugs por sprint usan este mismo
 * componente. No hace aritmética ni crea objetos al pintar — el modelo llega listo del VM — y el hover
 * solo cambia un índice. Es la forma de no repetir B-062, donde la animación de Chart.js dentro de la
 * zona de Angular y una plantilla que fabricaba objetos trabaron la pantalla.
 *
 * Las marcas van en un SVG estirado y los textos, puntos y tooltip en HTML encima, en %: el texto
 * no se deforma a ningún ancho y no hace falta medir nada al redimensionar.
 */
@Component({
  selector: 'app-metric-chart',
  templateUrl: './metric-chart.component.html',
  styleUrls: ['./metric-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetricChartComponent {
  @Input() model!: ChartModel
  /** Alto del área de trazado, en px. */
  @Input() height = 220

  hover = -1

  /** Centro de la posición en hover: el tooltip se pega a un lado y no tapa el punto. */
  tipX(i: number): number {
    return this.model.slots[i]?.x ?? 50
  }

  /** En la mitad derecha el tooltip abre hacia la izquierda: cada lado tiene la mitad del ancho libre. */
  tipToLeft(i: number): boolean {
    return this.tipX(i) > 50
  }

  track(i: number): number {
    return i
  }
}
